import { GLOBAL } from 'saddlebag-browser';

import type { LocationChangedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { Location } from 'react-router-dom';

export const LOCATION_CHANGED = 'LOCATION_CHANGED';

const getFullUrl = (location: Location) => {
  const $window = GLOBAL.getWindow();
  return `${$window.location.origin}${location.pathname}${location.search}${location.hash}`;
};

export const locationChanged = (
  location: Location,
  prevLocation: Location,
): LocationChangedAction => {
  const referrer = prevLocation ? getFullUrl(prevLocation) : '';
  return {
    type: LOCATION_CHANGED,
    payload: {
      location,
      referrer,
      prevLocation,
    },
  };
};
